











































import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component
export default class ActionBar extends Vue {
  @Prop({ default: 0 }) readonly step!: number;
  @Prop({ default: false }) readonly canGo!: boolean;

  get isBackDisabled() {
    return this.step == 0;
  }

  get isGoDisabled() {
    return !this.canGo;
  }

  onBackClick() {
    this.$emit("go", this.step - 1);
  }

  onNextClick() {
    this.$emit("go", this.step + 1);
  }

  onSaveClick() {
    this.$emit("save");
  }
}
